import React, { useMemo, useState, useEffect, useRef } from 'react';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import { Pagination } from '@egjs/flicking-plugins';
import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/flicking-plugins/dist/pagination.css';
import './SlideStore.css'
import CardStore from '../CardStore/CardStore';

const SlideStore = props => {

    const { data, selectedSlideIndex, onSlideChange } = props
    const flickingRef = useRef(null)
    const [isFlickingReady, setIsFlickingReady] = useState(false)
    const [activeIndex, setActiveIndex] = useState(selectedSlideIndex)

    useEffect(() => {
        if(flickingRef.current){
            flickingRef.current.on('ready', () => {
                setIsFlickingReady(true)
            })
        }
    },[])

    useEffect(() => {
        if (isFlickingReady && flickingRef.current) {
            flickingRef.current.moveTo(selectedSlideIndex, 500); // O segundo parâmetro é a duração da animação
            setActiveIndex(selectedSlideIndex);
        }
    }, [selectedSlideIndex, isFlickingReady]);

    const handleMoveEnd = (e) => {
        const newIndex = e.index
        setActiveIndex(newIndex)
        onSlideChange(newIndex)
    }

    const plugins = useMemo(() => [new Pagination()], []);
    return (
        <div className="slide-store">
            <section className="section-container">

                <Flicking
                ref={flickingRef}
                    circular={true}
                    plugins={plugins}
                    onChanged={handleMoveEnd}
                >
                    {data.map((card, i) => {
                        return (
                            <div key={i} className={`slide-item ${activeIndex !== i ? 'slide-item-inative' : ''}`}>
                                <CardStore
                                    cardTitle={card.cardTitle}
                                    cardAdress={card.cardAdress}
                                    cardPhone={card.cardPhone}
                                    iconPhone={card.iconPhone}
                                    cardOperation={card.cardOperation}
                                    iconOperation={card.iconOperation}
                                />
                            </div>
                        )
                    })}
                    <ViewportSlot>
                        <div className='flicking-pagination'></div>
                    </ViewportSlot>
                </Flicking>
            </section>
        </div>
    )
}

export default SlideStore;